import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchMedicationMapping(medicationIds) {
    return useQuery(['medicationMapping', medicationIds], () => PESService.getMedicationMapping(medicationIds), {
        enabled: Array.isArray(medicationIds) && medicationIds.length > 0,
        retry: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchMedicationMapping;
